<template>
    <div v-if="loading_curso === true">
      <loading />
    </div>
    <div v-else>
      <div class="col s12 m12 no-padding doc-type-section">
        <div class="col s12 buttons-wrapper">
          <a v-if="form_grad === false" @click="addNewGrad(true)" class="waves-effect waves-light btn right">Adicionar graduação</a>
          <a v-else @click="addNewGrad(false)" class="waves-effect waves-light btn red right">Cancelar</a>
        </div>
        <template v-if="form_grad === false">
          <!-- v-for na div abaixo -->
          <template v-for="(curso, i) in cursos">
            <div class="col s12 m6" v-bind:key="i">
              <div class="card">
                <div class="card-content">
                  <ul>
                    <li><p>Tipo de Formação: <span>{{ pf_curso_graus[curso.curso_grau] }}</span></p></li>
                    <li><p>Curso: <span>{{ curso.curso }}</span></p></li>
                    <li><p>Situação do curso: <span>{{ pf_curso_situacoes[curso.curso_situacao] }}</span></p></li>
                    <li><p>Ano de conclusão (ou previsto): <span>{{ curso.curso_ano_conclusao }}</span></p></li>
                  </ul>
                  <a @click="removerCurso(curso.curso_id)" data-position="top" data-tooltip="Remover formação" class="tooltipped action-delete">
                    <i class="material-icons">delete</i>
                  </a>
                </div>
              </div>
            </div>
          </template>
        </template>
        <template v-else>
          <div class="input-field col s12 m6">
            <select v-model="new_curso.pf_curso_grau" id="pf_curso_grau">
              <option v-bind:value="null" selected>Selecione</option>
              <option v-for="(grau, i) in pf_curso_graus" v-bind:key="i" v-bind:value="i">{{ grau }}</option>
            </select>
            <label for="pf_curso_grau">Tipo da formação</label>
          </div>
          <div class="input-field col s12 m6">
            <input v-model="new_curso.pf_curso" id="pf_curso" type="text" class="validate">
            <label for="pf_curso">Curso</label>
          </div>
          <div class="input-field col s12 m6">
            <select v-model="new_curso.pf_curso_situacao" id="pf_curso_situacao">
              <option v-bind:value="null" selected>Selecione</option>
              <option v-for="(situacao, i) in pf_curso_situacoes" v-bind:key="i" v-bind:value="i">{{ situacao }}</option>
            </select>
            <label for="pf_curso_situacao">Situação da formação</label>
          </div>
          <div class="input-field col s12 m6">
            <input v-model="new_curso.pf_curso_ano_conclusao" id="pf_curso_ano_conclusao" maxlength="4" type="number" class="validate">
            <label for="pf_curso_ano_conclusao">Ano de conclusão</label>
          </div>
          <div class="input-field col s12 m12">
            <button @click="prepareSubmitCurso" v-bind:disabled="verificaForm === false" class="btn right" type="button">SALVAR</button>
          </div>
        </template>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import Loading from '@/components/Loading.vue'
import {converteData, formataData} from '@/assets/js/form-utils.js'
import {CONFIG} from '@/config/config.js'
import SocialService from '@/services/social-service.js'
import { verificaData } from '@/assets/js/form-utils'
import sha1 from 'js-sha1'

let socialService = new SocialService(CONFIG.URL_SOCIAL_API_V2)

export default {
  name: 'Graduacoes',
  components: {
    'loading': Loading,
  },
  props: {
      doc: Array,
      pf_id: String
  },
  data (){
    return {
      loading_curso: false,
      meta: this.$store.state.meta.data,
      new_curso: {
        pf_curso_grau: null,
        pf_curso_situacao: null,
        pf_curso: null,
        pf_curso_ano_conclusao: new Date().getFullYear()
      },
      pf_curso_graus: {
        'G': "Graduação",
        'PG': "Pós-Graduação/Especialização",
        'M': "Mestrado",
        'D': "Doutorado",
        'PD': "Pós-Doutorado"
      },
      pf_curso_situacoes: {
        'C': "Concluído",
        'CS': "Cursando",
        'A': "Abandonado"
      },
      cursos: this.doc,
      error_fields: {},
      loaded: null,
      form_grad: false
    }
  },
  computed: {
    verificaForm: function() {
      return Object.keys(this.new_curso).filter((k) => this.new_curso[k] && this.new_curso[k] != '').length === 4
    },
    years: function(params) {
      let ano_atual = (new Date()).getFullYear()
      let anos = []
      for(let i = ano_atual; i <= ano_atual + 7; i++){
        anos.push(i)
      }
      return anos
    }
  },
  methods: {
    async submitInsertCurso(curso){
      axios.post(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/cursos/`, {
        ...curso,
        ...{
          'device': await socialService.getDeviceInfo()
        }
      })
      .then((response) => {
        this.getCursos()
      })
      .catch((error) => {
        M.toast({html: 'Não foi possível realizar esta operação...verifique a sua conexão com a internet e tente novamente!'})
        this.loading_curso = false
        setTimeout(() => {
          this.initFields()
        }, 100)
      })
    },
    getCursos(){
      axios.get(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/cursos/${this.pf_id}/`)
      .then((response) => {
        this.cursos = []
        response.data.data.SocialAPI.forEach((curso) => {
          this.cursos.push({
            curso_id: curso['curso_id'],
            curso_grau: curso['pf_curso_grau'],
            curso_situacao: curso['pf_curso_situacao'],
            curso: curso['pf_curso'],
            curso_ano_conclusao: curso['pf_curso_ano_conclusao']
          })
        })
      })
      .catch((error) => {

      })
      .finally(() => {
        this.loading_curso = false
        setTimeout(() => {
          this.$emit('statusChange', {
            doc: 8,
            status: (this.cursos.length > 0)
          })
          this.initFields()
          this.form_grad = false
        }, 100)
      })
    },
    prepareSubmitCurso(){
      this.loading_curso = true
      let a = this.new_curso //Atual

      let curso = {
        pf_id: this.pf_id,
        pf_curso_grau: this.new_curso.pf_curso_grau,
        pf_curso_situacao: this.new_curso.pf_curso_situacao,
        pf_curso: this.new_curso.pf_curso,
        pf_curso_ano_conclusao: this.new_curso.pf_curso_ano_conclusao
      }

      if(this.loaded !== sha1(JSON.stringify(curso))){
        return this.submitInsertCurso(curso)
      } else {
        this.loading_curso = false
        this.form_grad = false
      }
    },
    addNewGrad(op){
      this.form_grad = op
      this.new_curso = {
        pf_curso_grau: null,
        pf_curso_situacao: null,
        pf_curso: null,
        pf_curso_ano_conclusao: new Date().getFullYear()
      }
      setTimeout(() => {
        M.updateTextFields()
        M.FormSelect.init(document.querySelectorAll('select'))
      }, 300)
    },
    async removerCurso(curso_id){
      this.loading_curso = true
      axios({
        method: "DELETE",
        url: `${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/cursos/${this.pf_id}/${curso_id}/`, 
        data: {
          device: await socialService.getDeviceInfo()
        }
      })
      .then((response) => {

        this.cursos.forEach((item, i) => {
          if(item['curso_id'] === curso_id){
            this.cursos.splice(i, 1)
          }
        })

        this.loading_curso = false
        setTimeout(() => {
          this.initFields()
          this.form_grad = false
        }, 100)
      })
      .catch((error) => {
        M.toast({html: 'Não foi possível realizar esta operação...verifique a sua conexão com a internet e tente novamente!'})
        this.loading_curso = false
        setTimeout(() => {
          this.initFields()
        }, 100)
      })
    },
    initFields () {
      M.updateTextFields()
      M.FormSelect.init(document.querySelectorAll('select'))
    },
    verificaStatusDocumento(){
      return true //Não obrigatório
    }
  },
  mounted(){
    this.initFields()
    setTimeout(() => {
      this.$emit('statusChange', {
        doc: 8,
        status: (this.cursos.length > 0)
      })
    }, 300)
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/steps/documentos/Graduacoes.vue